import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  size?: 'normal' | 'large';
  showTrust?: boolean;
}
export function CTAButton({
  text,
  subtext,
  size = 'normal',
  showTrust = true
}: CTAButtonProps) {
  const isLarge = size === 'large';
  const handleClick = () => {
    trackEvent('InitiateCheckout', {
      content_name: 'Protocolo 24H: Salto Cuántico',
      content_category: 'Digital Product',
      value: 19990,
      currency: 'ARS'
    });
  };
  return <div className="flex flex-col items-center gap-4" data-id="element-37">
      <motion.a href="https://checkout.guiadigital360.online/cart/44800196640837:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} className={`
          inline-block text-center font-body font-bold uppercase tracking-wide
          bg-brand-gold text-[#0A0A0A] rounded-lg
          transition-shadow duration-300
          hover:bg-brand-gold-light hover:shadow-[0_0_40px_rgba(212,175,55,0.5)]
          shadow-[0_0_20px_rgba(212,175,55,0.25)]
          ${isLarge ? 'px-10 py-5 text-lg md:text-xl' : 'px-8 py-4 text-base md:text-lg'}
        `} data-id="element-38">
        {text}
      </motion.a>
      {subtext && <p className="text-brand-muted text-sm italic" data-id="element-39">{subtext}</p>}
      {showTrust && <p className="text-brand-muted-dark text-xs tracking-wide" data-id="element-40">
          ✓ Pago seguro · ✓ Descarga instantánea · ✓ Garantía 7 días · ✓ 390
          páginas
        </p>}
    </div>;
}